import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/shared.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  isLoggedIn = true;
  username;

  constructor(private auth: AuthService, private router: Router, private sharedService: SharedService) {
    
  }

  ngOnInit() {
    this.auth.getLoginStatus().subscribe(
      (a) => {
        if (a != null) {
          this.isLoggedIn = true;
        }
        else {
          this.isLoggedIn = false
        }
      }
    )
    this.sharedService.displayName.subscribe(
      (a)=>{
        this.username = a;
        console.log(a);
      }
    )
  }

  signOut() {
    localStorage.clear();
    this.auth.signOut();
    this.router.navigate(['/sign-in'])
  }

}
